import { ShopDataField } from 'src/services';

export function dataFieldHasTypes(dataField: ShopDataField) {
  return dataField.types.length > 0;
}
